const { errorDefinitions } = require("@/utils/errorAlert/errorDefinitions");

export const HeaderMapping = {
    0: "สถานะการสมัคร",
    1: "อัปโหลดเอกสาร",
};

export const mappingError = (code, head) => {
    const errorData = errorDefinitions[code] || errorDefinitions["default"];
    return {
        ...errorData,
        header: HeaderMapping[head],
    };
};
